import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  PopoverController,
  ModalController,
  Platform,
} from "ionic-angular";

import { PostPopoverComponent } from "../../../components/post-popover/post-popover";
import { PostPage } from "../post/post";
import { NewPostPage } from "../new-post/new-post";
import { SearchPage } from "../search/search";
import { ProfilePage } from "../profile/profile";
import { AvatarProvider } from "../../../providers/avatar/avatar";
import { AuthProvider } from "../../../providers/auth/auth";
import { OnesignalProvider } from "../../../providers/onesignal/onesignal";

@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {

  searchQuery = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public avatarProvider: AvatarProvider,
    public authProvider: AuthProvider,
    public onesignalProvider: OnesignalProvider,
    public modalCtrl: ModalController,
    platform: Platform
  ) {
    platform.ready().then(() => {
      avatarProvider.get(this.authProvider.user.avatar_id).subscribe((res) => {
        authProvider.setUserAvatar(this.ab2str(res.data.avatar_content.data));
      });

      // Onsignal :
      try {
        window["plugins"].OneSignal.setLogLevel({
          logLevel: 6,
          visualLevel: 0,
        });

        var notificationOpenedCallback = function (jsonData) {
          console.log(
            "notificationOpenedCallback: " + JSON.stringify(jsonData)
          );
        };

        // Set your iOS Settings
        var iosSettings = {};
        iosSettings["kOSSettingsKeyAutoPrompt"] = false;
        iosSettings["kOSSettingsKeyInAppLaunchURL"] = false;

        window["plugins"].OneSignal.startInit(
          "be97032f-02a1-4628-b9ef-4ba6f67fc357"
        )
          .handleNotificationOpened(notificationOpenedCallback)
          .iOSSettings(iosSettings)
          .inFocusDisplaying(
            window["plugins"].OneSignal.OSInFocusDisplayOption.Notification
          )
          .endInit();

        window["plugins"].OneSignal.promptForPushNotificationsWithUserResponse(
          function (accepted) {
            if (accepted) {
              window["plugins"].OneSignal.getIds((id) => {
                if (typeof id !== "undefined") {
                  onesignalProvider
                    .storePlayerId(id.userId)
                    .subscribe((res) => {
                      console.log(res);
                    });
                }
              });
            }
          }
        );
      } catch (e) {}
    });
  }

  ionViewDidLoad() {}

  presentPopover(event) {
    event.stopPropagation();

    let popover = this.popoverCtrl.create(
      PostPopoverComponent,
      {},
      {
        cssClass: "my-popover",
      }
    );
    popover.present({
      ev: event,
    });
  }

  // Decoding image buffer
  ab2str(arraybuffer) {
    return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer));
  }

  goToPost(postId) {
    this.navCtrl
      .push(PostPage, {
        postId: postId,
      })
      .then(() => {
        console.log("Welcome to post:", postId);
      });
  }

  newPost() {
    let modal = this.modalCtrl.create(NewPostPage, {
      isClub: false,
      clubId: "",
    });
    modal.present();
  }

  goToSearch() {
    this.navCtrl.push(SearchPage, {}).then(() => {
      console.log("Welcome to search");
    });
  }

  goToProfile() {
    this.modalCtrl.create(ProfilePage, {}).present().then(() => {});

  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/home/home.ts